<template>
  <div class="flex flex-col h-screen bg-slate-50">
    <AppHeader toggle>
      <template #right>
        <div
          v-if="user !== undefined"
          class="hidden lg:flex items-center gap-2"
        >
          <!-- <div class="block">
            <UButton
              color="secondary"
              variant="soft"
              icon="i-lucide-chart-bar"
              :to="{ name: 'dashboard' }"
            >
              ไปที่แดชบอร์ด
            </UButton>
          </div> -->
          <AppMenuUserDropdown></AppMenuUserDropdown>
        </div>
      </template>
      <template #body>
        <UNavigationMenu
          orientation="vertical"
          :items="items"
          class="data-[orientation=vertical]:w-full"
        />
      </template>
    </AppHeader>
    <div class="flex flex-col flex-1 overflow-y-auto">
      <UContainer class="mt-8 pb-24">
        <slot />
      </UContainer>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NavigationMenuItem } from "@nuxt/ui";

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const items = computed<NavigationMenuItem[][]>(() => [
  // [
  //   {
  //     label: "ไปที่แดชบอร์ด",
  //     icon: "i-lucide-chart-bar",
  //     to: { name: "dashboard" },
  //   },
  // ],
  [
    {
      label: `${user.value?.first_name} ${user.value?.last_name}`,
      icon: "i-simple-icons-github",
      defaultOpen: true,
      children: [
        {
          label: "ออกจากระบบ",
          icon: "i-lucide-log-out",
          to: { name: "auth-logout" },
        },
      ],
    },
  ],
]);
</script>

<style scoped></style>
